module.exports = new __parcel__URL__("idea-engagement-darkmode.a19539a5.svg").toString();